// removed by extract-text-webpack-plugin
module.exports = {"left":"src-components-modules-HeadingBlock-style----align-module---left---1239h textAlign-left","right":"src-components-modules-HeadingBlock-style----align-module---right---3OmdJ textAlign-right"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/HeadingBlock/style/align.module.css
// module id = 1467
// module chunks = 168707334958949